/**
 * Route for `native-reconciliation-link-conversions-to-stripe-bank-deposits`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { NativeReconciliationLinkConversionsToStripeBankDepositsPage } from "../features/native-reconciliation-link-conversions-to-stripe-bank-deposits/NativeReconciliationLinkConversionsToStripeBankDepositsPage";

export const nativeReconciliationLinkConversionsToStripeBankDepositsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/native-reconciliation-link-conversions-to-stripe-bank-deposits",
	component: NativeReconciliationLinkConversionsToStripeBankDepositsPage,
});

export default nativeReconciliationLinkConversionsToStripeBankDepositsRoute;
